export default {
      id: "i-service-analytics-usage",
      viewBox: "0 0 154 148",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-analytics",
      toString: function () {
        return this.url;
      }
    }